export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10135.308ac15f.jpg";